import { useCallback, useState } from "react";

const STORAGE_KEYS = {
  list: "mgmt-meeting-list-tour-completed",
  detail: "mgmt-meeting-detail-tour-completed",
  formCreate: "mgmt-meeting-form-create-tour-completed",
  formEdit: "mgmt-meeting-form-edit-tour-completed",
  actions: "mgmt-meeting-actions-tour-completed",
  pdfPreview: "mgmt-meeting-pdf-preview-tour-completed",
} as const;

export type MeetingTourPage = keyof typeof STORAGE_KEYS;

export function useMeetingTour(page: MeetingTourPage) {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const storageKey = STORAGE_KEYS[page];

  const hasCompletedTour = () => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(storageKey) === "true";
  };

  const startTour = useCallback(() => {
    setRun(true);
    setStepIndex(0);
  }, []);

  const stopTour = useCallback(() => {
    setRun(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(storageKey, "true");
    }
  }, [storageKey]);

  const handleJoyrideCallback = useCallback(
    (data: { status?: string; type?: string; index?: number }) => {
      if (data.index !== undefined) setStepIndex(data.index);
      if (
        data.status === "finished" ||
        data.status === "skipped" ||
        data.type === "tour:end"
      ) {
        stopTour();
      }
    },
    [stopTour],
  );

  return {
    run,
    stepIndex,
    startTour,
    stopTour,
    hasCompletedTour: hasCompletedTour(),
    handleJoyrideCallback,
  };
}
